import { useState, useEffect } from 'react';
import useAuth from '../hooks/useAuth';
export default function ImpersonationBanner() {
  const [timeLeft, setTimeLeft] = useState(0);
  const {showLoader, showInfo, showUpdate, auth} = useAuth();
  useEffect(() => {
    // Grab the expiration from localStorage
    const expireStr = localStorage.getItem('impersonation_expire'); // e.g., "2025-08-19 14:55:52"
    if (!expireStr) return;

    const expireTime = new Date(expireStr.replace(' ', 'T')).getTime(); // convert to timestamp
    const updateTime = () => {
      const now = Date.now();
      const diffSeconds = Math.max(Math.floor((expireTime - now) / 1000), 0);
      setTimeLeft(diffSeconds);
    };

    updateTime(); // set initial time

    const interval = setInterval(updateTime, 1000); // update every second
    return () => clearInterval(interval);
  }, []);

  const stopImpersonation = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('impersonation');
    localStorage.removeItem('impersonation_expire');
    setTimeout(() => {
    window.close(); // reload the page to reflect changes

    }, 500)
  }

  // Convert seconds to mm:ss format
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div
  style={{
    position: "fixed",
    top: 0,
    width: "100%",
    background: "#fdc55f",
    padding: "15px 25px", // only left/right padding
    left: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center"
  }}
>
  {/* Centered text container */}
  <div style={{ flex: 1, textAlign: "center"}}>
    <p className="text-sm text-black inline-block mr-1 font-medium">
      You are currently impersonating {auth.user.name}. Please be cautious with actions taken.
    </p>
    <p className="text-sm text-black inline-block font-medium">
      session ends in: {formatTime(timeLeft)}
    </p>
  </div>

  {/* Button pinned right */}
  <button 
    type="button"
    onClick={stopImpersonation} 
    className="ml-auto bg-red-400 border-2 border-red-400 text-white font-medium px-2 py-1 rounded-md hover:bg-red-600 hover:border-red-600 transition"
  >
    End Session
  </button>
</div>

  

  
  );
}
